import type { AnimatedProductCategory } from '@backmarket/nuxt-layer-cms/BaseAnimatedProductCheckpoints/types'

import { ProductCategory } from '../../constants'

export const CHECKPOINTS_CATEGORIES_MAPPING: Record<
  string,
  AnimatedProductCategory
> = {
  [ProductCategory.SMARTPHONE]: 'smartphones',
  [ProductCategory.MACBOOK_INTEL]: 'laptops',
  [ProductCategory.MACBOOK_M]: 'laptops',
  [ProductCategory.LAPTOP]: 'laptops',
  [ProductCategory.IPAD]: 'tablets',
  [ProductCategory.TABLETS]: 'tablets',
  [ProductCategory.GAMING_CONSOLE]: 'consoles',
  [ProductCategory.SMARTWATCH]: 'smartwatches',
  [ProductCategory.APPLE_WATCH]: 'smartwatches',
}
